<template>
  <section class="home">
    <div class="top-container" @mouseenter="isScrolled = false" @mouseleave="isScrolled = true">
      <Top :isScrolled="isScrolled"></Top>
    </div>
    <div id="top"></div>
    <div class="slide">
      <el-carousel trigger="click" :interval="5000">
        <el-carousel-item>
          <div class="mv-img-container">
            <div class="top-mask" style="background-color: rgb(0 0 0 / 20%);"></div>
            <img src="../assets/momingvision.webp" />
            <div class="mv-text-box">
              <div class="text">MomingVision是专为工业自动化场景打造的新一代无代码AI机器视觉软件。不用懂编程，就能快速实现「上下料、拆码垛、定位装配、检测测量」等智能机器人应用。</div>
              <svg @click="toLink('vision')" t="1749438642987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10834" width="42" height="42">
                <path d="M512 119.146496C729.197568 118.90688 905.484288 294.795264 905.730048 512c0.233472 217.197568-175.654912 393.483264-392.859648 393.730048-217.204736 0.233472-393.483264-175.654912-393.72288-392.859648 0-0.287744 0-0.582656 0-0.8704C119.387136 295.130112 295.131136 119.386112 512 119.146496M512 63.025152c-247.964672 0-448.974848 201.009152-448.974848 448.974848 0 247.97184 201.010176 448.974848 448.974848 448.974848 247.97184 0 448.974848-201.003008 448.974848-448.974848C960.974848 264.034304 759.97184 63.025152 512 63.025152L512 63.025152zM549.706752 690.916352c7.440384 0.013312 14.578688-2.946048 19.84-8.220672L735.296512 512.575488 569.520128 342.441984c-10.770432-11.14624-28.526592-11.454464-39.68-0.6912-11.140096 10.769408-11.44832 28.53376-0.685056 39.68 0.219136 0.233472 0.464896 0.46592 0.685056 0.692224L660.333568 512.603136 529.840128 643.083264c-10.913792 11.00288-10.845184 28.760064 0.149504 39.694336C535.237632 687.983616 542.308352 690.902016 549.706752 690.916352zM315.292672 539.758592l360.866816 0c15.497216 0 28.060672-12.577792 28.060672-28.06784 0-15.496192-12.56448-28.060672-28.060672-28.060672l-360.866816 0c-15.496192 0-28.060672 12.56448-28.060672 28.060672C287.232 527.1808 299.79648 539.758592 315.292672 539.758592z" p-id="10835" fill="#ffffff">
                </path>
              </svg>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="img-container">
            <div class="top-mask"></div>
            <img src="../assets/robot-banner.webp" />
            <div class="text-box">
              <div class="desc">机器人集群：专注于机器人技术，为客户提供安全可靠的<br>智能机器人工作站</div>
              <!-- <svg @click="toLink('robot')" t="1749438642987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10834" width="42" height="42">
                <path d="M512 119.146496C729.197568 118.90688 905.484288 294.795264 905.730048 512c0.233472 217.197568-175.654912 393.483264-392.859648 393.730048-217.204736 0.233472-393.483264-175.654912-393.72288-392.859648 0-0.287744 0-0.582656 0-0.8704C119.387136 295.130112 295.131136 119.386112 512 119.146496M512 63.025152c-247.964672 0-448.974848 201.009152-448.974848 448.974848 0 247.97184 201.010176 448.974848 448.974848 448.974848 247.97184 0 448.974848-201.003008 448.974848-448.974848C960.974848 264.034304 759.97184 63.025152 512 63.025152L512 63.025152zM549.706752 690.916352c7.440384 0.013312 14.578688-2.946048 19.84-8.220672L735.296512 512.575488 569.520128 342.441984c-10.770432-11.14624-28.526592-11.454464-39.68-0.6912-11.140096 10.769408-11.44832 28.53376-0.685056 39.68 0.219136 0.233472 0.464896 0.46592 0.685056 0.692224L660.333568 512.603136 529.840128 643.083264c-10.913792 11.00288-10.845184 28.760064 0.149504 39.694336C535.237632 687.983616 542.308352 690.902016 549.706752 690.916352zM315.292672 539.758592l360.866816 0c15.497216 0 28.060672-12.577792 28.060672-28.06784 0-15.496192-12.56448-28.060672-28.060672-28.060672l-360.866816 0c-15.496192 0-28.060672 12.56448-28.060672 28.060672C287.232 527.1808 299.79648 539.758592 315.292672 539.758592z" p-id="10835" fill="#ffffff">
                </path>
              </svg> -->
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="img-container">
            <div class="top-mask" style="background-color: rgb(0 0 0 / 20%);"></div>
            <img src="../assets/twins-banner.webp" />
            <div class="text-box text-box-num">
              <div class="desc-num">数字孪生解决方案：采用最新的软件技术和可靠的硬件设备，可以<br>针对客户需求，提供高度定制开发方案，高效快速的安装部署</div>
              <!-- <svg @click="toLink('twins')" t="1749438642987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10834" width="42" height="42">
                <path d="M512 119.146496C729.197568 118.90688 905.484288 294.795264 905.730048 512c0.233472 217.197568-175.654912 393.483264-392.859648 393.730048-217.204736 0.233472-393.483264-175.654912-393.72288-392.859648 0-0.287744 0-0.582656 0-0.8704C119.387136 295.130112 295.131136 119.386112 512 119.146496M512 63.025152c-247.964672 0-448.974848 201.009152-448.974848 448.974848 0 247.97184 201.010176 448.974848 448.974848 448.974848 247.97184 0 448.974848-201.003008 448.974848-448.974848C960.974848 264.034304 759.97184 63.025152 512 63.025152L512 63.025152zM549.706752 690.916352c7.440384 0.013312 14.578688-2.946048 19.84-8.220672L735.296512 512.575488 569.520128 342.441984c-10.770432-11.14624-28.526592-11.454464-39.68-0.6912-11.140096 10.769408-11.44832 28.53376-0.685056 39.68 0.219136 0.233472 0.464896 0.46592 0.685056 0.692224L660.333568 512.603136 529.840128 643.083264c-10.913792 11.00288-10.845184 28.760064 0.149504 39.694336C535.237632 687.983616 542.308352 690.902016 549.706752 690.916352zM315.292672 539.758592l360.866816 0c15.497216 0 28.060672-12.577792 28.060672-28.06784 0-15.496192-12.56448-28.060672-28.060672-28.060672l-360.866816 0c-15.496192 0-28.060672 12.56448-28.060672 28.060672C287.232 527.1808 299.79648 539.758592 315.292672 539.758592z" p-id="10835" fill="#ffffff">
                </path>
              </svg> -->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <Bottom></Bottom>
    </div>
    <div style="z-index: 9999;">
      <Backtop></Backtop>
    </div>
  </section>
</template>

<script>
import Top from '@/components/top/Top'
import Bottom from '@/components/bottom/Bottom'
import Backtop from '@/components/BackTop.vue'

export default {
  name: 'HomeView',
  components: {
    Top,
    Bottom,
    Backtop
  },
  data() {
    return {
      isScrolled: true
    }
  },
  methods:{
    toLink(target){
      if(target == 'robot'){
        window.location.href = `https://mmkj.mominger.com:8443/product5`
        return
      }else if(target == 'twins'){
        window.location.href = `https://mmkj.mominger.com:8443/product1`
        return
      }else if(target == 'vision'){
        window.open('https://mmkj.mominger.com:6443/', '_blank');
        return
      }
      window.location.href = `https://mmkj.mominger.com`
    }
  }
}
</script>

<style lang="less" scoped>
section.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  .top-container {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    z-index: 1100;
    display: flex;
    justify-content: center;
  }
  .slide {
    width: 100%;
    height: 100vh;
    .mv-img-container{
      height: 100vh;
      width: 100%;
      position: relative;
      img{
        position: absolute;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .top-mask{
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgb(0 0 0 / 45%);
        z-index: 3;
      }
      .mv-text-box{
        width: 30%;
        letter-spacing: 2px;
        position: absolute;
        z-index: 9;
        font-size: 20px;
        right: 4%;
        top: 48%;
        color: #ffffff;
        text-indent: 40px;
        line-height: 1.8;
        text-align: center;
        svg{
          cursor: pointer;
          margin-top: 20px;
          transition: transform 0.3s ease;
        }
        svg:hover {
          transform: translateY(-5px)
        }
      }
    }
    .img-container{
      height: 100vh;
      width: 100%;
      position: relative;
      .top-mask{
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgb(0 0 0 / 45%);
        z-index: 3;
      }
      .text-box,.text-box-num{
          position: relative;
          margin: 0 auto;
          padding-top: 400px;
          text-align: center;
          width: 80%;
          z-index: 9;
          color: #fff;
          font-size: 4rem;
          font-weight: bold;
        .desc, .desc-num {
          font-size: clamp(16px, 2.5vw, 40px);
          white-space: normal;
          overflow: visible;
          line-height: 1.5;
          max-width: 100%;
          margin: 0 auto;
        }
        svg{
          cursor: pointer;
          margin-top: 20px;
          transition: transform 0.3s ease;
        }
        svg:hover {
          transform: translateY(-5px)
        }
      }
      img{
        position: absolute;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    ::v-deep .el-carousel__indicators--horizontal{
      bottom: 25px;
    }
  }
}
::v-deep .el-carousel__container {
  height: 100vh;
}

// 小屏幕适配
@media (max-width: 768px) {
  section.home .slide .img-container .text-box,
  section.home .slide .img-container .text-box-num {
    width: 90%; // 平板端进一步扩大容器宽度
    padding-top: 350px;
  }
  .desc, .desc-num {
    font-size: clamp(14px, 3vw, 24px) !important;
    line-height: 1.6 !important;
  }
}

@media (max-width: 480px) {
  section.home .slide .img-container .text-box,
  section.home .slide .img-container .text-box-num {
    width: 95%; // 手机端几乎占满宽度
    padding-top: 300px;
  }
  .desc, .desc-num {
    font-size: clamp(12px, 4vw, 20px) !important;
    line-height: 1.7 !important;
  }
}
</style>